ApplyCancelButtons = require 'components/common/apply_cancel_buttons'
CheckboxInput = require 'components/common/checkbox_input'
Modal = require 'components/common/modal'
OutcomesSelect = require 'components/common/outcomes_select'
Select = require 'components/common/select'
ConnectStore = require 'components/enhancers/connect_store'
NMAListActions = require 'actions/nma_list_actions'
NMAListStore = require 'stores/nma_list_store'
NMAQuestionStore = require 'stores/nma_question_store'
mediator = require 'mediator'
useTranslation = require 'components/hooks/use_translation'
{ insertGdtTable } = require 'lib/epiditor_utils'
{
  buildNmaData
  buildNmaPrintoutTableData
  getDefaultVizConfig
} = require 'lib/nma_printout_table_helper'
{ useEffect, useState } = React
{ PMView } = Epiditor

COMMON_COMPARATOR = 'CommonComparator'
COMMON_INTERVENTION = 'CommonIntervention'
PAIRWISE = 'Pairwise'

storeConnector =
  NMAListStore: (Store) ->
    isFetchingNmaQuestions: Store.isFetching()
    nmaQuestions: Store.getQuestions()
  NMAQuestionStore: (Store) ->
    nmaOutcomes: Store.getOutcomes()

NMAPrintoutTableInsertModal = ({
  isFetchingNmaQuestions
  nmaOutcomes
  nmaQuestions
  onClose
  onInsert
}) ->
  i18n = useTranslation ''
  [selectedQuestionId, setSelectedQuestionId] = useState null
  [comparatorTableMode, setComparatorTableMode] = useState null
  [comparatorId, setComparatorId] = useState null
  [selectedInterventionIds, setSelectedInterventionIds] = useState null
  [selectedOutcomeIds, setSelectedOutcomeIds] = useState null
  [interventionComparisonPairs, setInterventionComparisonPairs] = useState null
  [pairwiseInterventionId, setPairwiseInterventionId] = useState null
  [pairwiseComparatorId, setPairwiseComparatorId] = useState null
  [denominator, setDenominator] = useState null
  [showThresholds, setShowThresholds] = useState null
  [showHighlights, setShowHighlights] = useState null

  useEffect(
    ->
      shouldFetch = not isFetchingNmaQuestions and
        (nmaQuestions.isEmpty() or nmaOutcomes.isEmpty())
      return undefined unless shouldFetch

      cancelled = false
      _.defer ->
        return if cancelled
        NMAListActions.fetchAllQuestionsAndOutcomes dbId: mediator.project.id

      ->
        cancelled = true
    [isFetchingNmaQuestions, nmaQuestions, nmaOutcomes]
  )

  questionOptions = nmaQuestions
    .map (question) ->
      value: question.get('_id')
      text: question.get('question')
    .toArray()

  effectiveQuestionId = selectedQuestionId ? questionOptions[0]?.value
  question = nmaQuestions.find (question) -> question.get('_id') is effectiveQuestionId
  nmaData = buildNmaData question, nmaOutcomes
  defaultConfig = if nmaData then getDefaultVizConfig question, nmaData else {}

  interventions = nmaData?.interventions ? []
  outcomes = nmaData?.outcomes ? []
  availableInterventionIds = interventions.map (intervention) -> intervention.id
  availableOutcomeIds = outcomes.map (outcome) -> outcome.id
  effectiveComparatorTableMode = comparatorTableMode ? defaultConfig.comparatorTableMode
  effectiveComparatorId = if comparatorId in availableInterventionIds
    comparatorId
  else if defaultConfig.comparatorId in availableInterventionIds
    defaultConfig.comparatorId
  else
    availableInterventionIds[0]
  effectiveSelectedInterventionIds = if selectedInterventionIds?
    selectedInterventionIds.filter (interventionId) ->
      interventionId in availableInterventionIds and interventionId isnt effectiveComparatorId
  else
    (defaultConfig.selectedInterventionIds ? []).filter (interventionId) ->
      interventionId in availableInterventionIds and interventionId isnt effectiveComparatorId
  effectiveSelectedOutcomeIds = if selectedOutcomeIds?
    selectedOutcomeIds.filter (outcomeId) -> outcomeId in availableOutcomeIds
  else
    (defaultConfig.selectedOutcomeIds ? availableOutcomeIds).filter (outcomeId) ->
      outcomeId in availableOutcomeIds
  effectiveInterventionComparisonPairs = if interventionComparisonPairs?
    interventionComparisonPairs.filter ([interventionId, comparatorId]) ->
      interventionId in availableInterventionIds and comparatorId in availableInterventionIds
  else
    (defaultConfig.interventionComparisonPairs ? []).filter ([interventionId, comparatorId]) ->
      interventionId in availableInterventionIds and comparatorId in availableInterventionIds
  effectiveDenominator = String(denominator ? defaultConfig.denominator ? NmaComponents.STANDARD_DENOMINATOR)
  effectiveShowThresholds = showThresholds ? defaultConfig.showThresholds ? true
  effectiveShowHighlights = showHighlights ? defaultConfig.showHighlights ? true

  interventionOptions = interventions.map (intervention) ->
    value: intervention.id
    text: intervention.name
  selectedInterventionOptions = interventions
    .filter (intervention) -> intervention.id isnt effectiveComparatorId
    .map (intervention) ->
      _id: intervention.id
      name: intervention.name
  outcomeSelectItems = Immutable.fromJS outcomes.map (outcome) ->
    _id: outcome.id
    name: outcome.name

  interventionSelectItems = Immutable.fromJS selectedInterventionOptions
  pairwiseFirstId = if pairwiseInterventionId in availableInterventionIds
    pairwiseInterventionId
  else
    availableInterventionIds[0]
  pairwiseSecondOptions = interventionOptions.filter (option) -> option.value isnt pairwiseFirstId
  pairwiseSecondId = if pairwiseComparatorId in pairwiseSecondOptions.map((option) -> option.value)
    pairwiseComparatorId
  else
    pairwiseSecondOptions[0]?.value

  updateSelectedInterventions = (selectedInterventions) ->
    setSelectedInterventionIds selectedInterventions.toArray()

  updateSelectedOutcomes = (selectedOutcomes) ->
    setSelectedOutcomeIds selectedOutcomes.toArray()

  changeComparator = (newComparatorId) ->
    nextSelectedInterventionIds = effectiveSelectedInterventionIds.filter (interventionId) ->
      interventionId isnt newComparatorId
    if effectiveComparatorId? and effectiveComparatorId isnt newComparatorId and
        effectiveComparatorId in availableInterventionIds and
        effectiveComparatorId not in nextSelectedInterventionIds
      nextSelectedInterventionIds.push effectiveComparatorId
    setSelectedInterventionIds nextSelectedInterventionIds
    setComparatorId newComparatorId

  changeTableMode = (newTableMode) ->
    setComparatorTableMode newTableMode

  addPair = ->
    return unless pairwiseFirstId and pairwiseSecondId
    return if pairwiseFirstId is pairwiseSecondId
    pairExists = effectiveInterventionComparisonPairs.some ([interventionId, comparatorId]) ->
      interventionId is pairwiseFirstId and comparatorId is pairwiseSecondId
    return if pairExists
    setInterventionComparisonPairs effectiveInterventionComparisonPairs.concat [[pairwiseFirstId, pairwiseSecondId]]

  removePair = (pairIndex) -> ->
    setInterventionComparisonPairs effectiveInterventionComparisonPairs.filter (_, index) ->
      index isnt pairIndex

  pairLabel = ([interventionId, comparatorId]) ->
    intervention = _.findWhere interventions, id: interventionId
    comparator = _.findWhere interventions, id: comparatorId
    "#{intervention?.name ? interventionId} #{i18next.t('nma:common.vs')} #{comparator?.name ? comparatorId}"

  submit = ->
    return unless effectiveQuestionId
    vizConfig =
      comparatorId: effectiveComparatorId
      comparatorTableMode: effectiveComparatorTableMode
      denominator: Number(effectiveDenominator)
      interventionComparisonPairs: effectiveInterventionComparisonPairs
      selectedInterventionIds: effectiveSelectedInterventionIds
      selectedOutcomeIds: effectiveSelectedOutcomeIds
      showHighlights: effectiveShowHighlights
      showThresholds: effectiveShowThresholds
    data = buildNmaPrintoutTableData question, nmaOutcomes, vizConfig
    return unless data
    onInsert
      type: 'nma_printout_table'
      qId: effectiveQuestionId
      comparatorId: vizConfig.comparatorId
      comparatorTableMode: vizConfig.comparatorTableMode
      denominator: vizConfig.denominator
      interventionComparisonPairs: vizConfig.interventionComparisonPairs
      renderMode: 'printout'
      selectedInterventionIds: vizConfig.selectedInterventionIds
      selectedOutcomeIds: vizConfig.selectedOutcomeIds
      showHighlights: vizConfig.showHighlights
      showThresholds: vizConfig.showThresholds
      data:
        title: data.settings?.title ? i18n 'editor.insert_nma_printout_table'

  sourceDisabled = questionOptions.length is 0
  dataDisabled = not nmaData? or interventions.length is 0 or outcomes.length is 0
  commonModeDisabled = effectiveComparatorTableMode isnt PAIRWISE and (
    not effectiveComparatorId? or effectiveSelectedInterventionIds.length is 0
  )
  pairwiseModeDisabled = effectiveComparatorTableMode is PAIRWISE and
    effectiveInterventionComparisonPairs.length is 0
  outcomesDisabled = effectiveSelectedOutcomeIds.length is 0
  submitDisabled = sourceDisabled or dataDisabled or commonModeDisabled or pairwiseModeDisabled or outcomesDisabled

  <Modal isOpen
    className='etd-insert-modal'
    onClose={onClose}
    title={i18n 'editor.insert_nma_printout_table'}
    closeButton
  >
    <div>
      <div className="insert-options nma-printout-insert-options">
        <div className="mb-10">
          <span>{i18n 'editor.source_question'}:</span>
          <Select
            options={questionOptions}
            selected={effectiveQuestionId}
            onChange={setSelectedQuestionId}
            style={width: '100%'}
          />
        </div>
        {sourceDisabled and <div className="error">{i18n 'editor.no_nma_questions'}</div>}
        {not sourceDisabled and dataDisabled and
          <div className="error">{i18n 'nma:viz_app.common.no_data_found'}</div>
        }
        {not dataDisabled and
          <div>
            <div className="mb-10">
              <span>{i18n 'nma:viz_app.sidebar.table_options'}:</span>
              <Select
                options={[
                  { value: COMMON_COMPARATOR, text: i18n 'nma:viz_app.sidebar.common_comparator' }
                  { value: COMMON_INTERVENTION, text: i18n 'nma:viz_app.sidebar.common_intervention' }
                  { value: PAIRWISE, text: i18n 'nma:viz_app.sidebar.pairwise' }
                ]}
                selected={effectiveComparatorTableMode}
                onChange={changeTableMode}
                style={width: '100%'}
              />
            </div>
            {if effectiveComparatorTableMode is PAIRWISE
              <div className="mb-10">
                <span>{i18n 'nma:viz_app.sidebar.pairwise'}:</span>
                <div className="nma-printout-pairs">
                  {effectiveInterventionComparisonPairs.map (pair, index) ->
                    <div className="nma-printout-pair" key={"pair-#{index}"}>
                      <span>{pairLabel pair}</span>
                      <button type="button" className="btn btn-small" onClick={removePair index}>
                        &times;
                      </button>
                    </div>
                  }
                  <div className="nma-printout-pair-editor">
                    <Select
                      options={interventionOptions.filter (option) -> option.value isnt pairwiseSecondId}
                      selected={pairwiseFirstId}
                      onChange={setPairwiseInterventionId}
                      style={width: '40%'}
                    />
                    <Select
                      options={pairwiseSecondOptions}
                      selected={pairwiseSecondId}
                      onChange={setPairwiseComparatorId}
                      style={width: '40%'}
                    />
                    <button type="button" className="btn" onClick={addPair}>
                      {i18n 'nma:viz_app.sidebar.add'}
                    </button>
                  </div>
                </div>
              </div>
            else
              <div>
                <div className="mb-10">
                  <span>{i18n 'nma:viz_app.sidebar.comparator'}</span>
                  <Select
                    options={interventionOptions}
                    selected={effectiveComparatorId}
                    onChange={changeComparator}
                    style={width: '100%'}
                  />
                </div>
                <div className="mb-10">
                  <span>{i18n 'nma:viz_app.sidebar.interventions'}</span>
                  <div className="threshold-plot-outcomes-list insert-options">
                    <OutcomesSelect
                      key={"nma-interventions-#{effectiveQuestionId}-#{effectiveComparatorId}"}
                      idPrefix={"nma-interventions-#{effectiveQuestionId}-#{effectiveComparatorId}"}
                      outcomes={interventionSelectItems}
                      selectedOutcomes={Immutable.List effectiveSelectedInterventionIds}
                      updateSelectedOutcomes={updateSelectedInterventions}
                    />
                  </div>
                </div>
              </div>
            }
            <div className="mb-10">
              <span>{i18n 'nma:viz_app.sidebar.outcomes'}</span>
              <div className="threshold-plot-outcomes-list insert-options">
                <OutcomesSelect
                  key={"nma-outcomes-#{effectiveQuestionId}"}
                  idPrefix={"nma-outcomes-#{effectiveQuestionId}"}
                  outcomes={outcomeSelectItems}
                  selectedOutcomes={Immutable.List effectiveSelectedOutcomeIds}
                  updateSelectedOutcomes={updateSelectedOutcomes}
                />
              </div>
            </div>
            <div className="mb-10">
              <span>{i18n 'nma:viz_app.sidebar.denominator_for_risk_differences'}</span>
              <Select
                options={[100, 1000, 10000, 100000].map (value) ->
                  value: String(value)
                  text: String(value)
                }
                selected={effectiveDenominator}
                onChange={setDenominator}
                style={width: '100%'}
              />
            </div>
            <div className="mb-10">
              <label>
                <CheckboxInput
                  checked={effectiveShowThresholds}
                  onChange={(e) -> setShowThresholds e.currentTarget.checked}
                />
                {i18n 'nma:viz_app.sidebar.thresholds'}
              </label>
            </div>
            <div className="mb-10">
              <label>
                <CheckboxInput
                  checked={effectiveShowHighlights}
                  onChange={(e) -> setShowHighlights e.currentTarget.checked}
                />
                {i18n 'nma:viz_app.sidebar.highlights'}
              </label>
            </div>
          </div>
        }
      </div>
      <ApplyCancelButtons
        onApply={submit}
        onCancel={onClose}
        isSubmitEnabled={not submitDisabled}
        applyLabel={i18n 'actions.insert'}
      />
    </div>
  </Modal>

ConnectedNMAPrintoutTableInsertModal = ConnectStore NMAPrintoutTableInsertModal,
  [NMAListStore, NMAQuestionStore],
  storeConnector

NMAPrintoutTableInsertControl = ({ view, onCloseMenu }) ->
  i18n = useTranslation ''
  [isModalOpen, setIsModalOpen] = useState false
  canInsert = insertGdtTable(view.state)({})

  closeModal = ->
    setIsModalOpen false
    onCloseMenu()

  handleInsert = (content) ->
    view.focus()
    insertGdtTable(view.state, view.dispatch)(content)
    closeModal()

  handleClick = (evt) ->
    evt.preventDefault()
    evt.stopPropagation()
    setIsModalOpen true

  <div>
    <div
      className={classNames 'gdt-table-insert-toggle', disabled: !canInsert}
      onMouseDown={handleClick if canInsert}
    >
      <span>{i18n 'actions.insert_nma_printout_table'}</span>
    </div>
    {isModalOpen and
      <ConnectedNMAPrintoutTableInsertModal
        onClose={closeModal}
        onInsert={handleInsert}
      />
    }
  </div>

NMAPrintoutTableInsertControl.propTypes =
  view: PropTypes.instanceOf(PMView.EditorView).isRequired

module.exports = NMAPrintoutTableInsertControl
